import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { AuthService } from "../../auth/services/auth.service";


@Injectable({
    providedIn: 'root'
})

export class AuthGuard implements CanActivate{
    constructor(
        private authService:AuthService,
        private router:Router
    ){}

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
        const isLoginRoute = next.url[0]?.path === 'login';

        if (this.authService.isAuthenticated()) {
            return isLoginRoute ? this.router.createUrlTree(['/']) : true;
        }

        return isLoginRoute ? true : this.router.createUrlTree(['/auth/login']);
    }
}
  
